const ProductUtils = {

	selectors: {
		add_to_cart: '.app-add-to-cart',
		lease_calculate: '.js-lease-calculate',
		price_block: '.js-price-block',
		instock_caption: '.js-instock-caption',
		product_availability: '.js-product-availability',
		product_options: '.js-product-options',
		product_variations: '.js-variations',
		button_inquire: '[name="inquire"]',
		price_label: '.js-product-price-label:not(.js-map-show):not(.js-map-hide):not(.js-map-remove)',
		use_map_price: '.js-use-map-price'
	},

	update_price(value) {
		const price_label_el = document.querySelector(this.selectors.price_label);

		if (price_label_el) {
			if (value) {
				let price_money = String(value.money());
				price_label_el.textContent = price_money;
				price_label_el.classList.remove('hide');
				price_label_el.setAttribute('data-price', value);
			} else {
				price_label_el.classList.add('hide');
			}
		}
	},

	check_product_has_been_removed(product, product_id) {
		if (product.IsBot || !product.IsDeleted) {
			return false;
		}
		document.querySelector('body').classList.add('has-been-removed');
		window.product_removed_elements = document.querySelectorAll(this.selectors.lease_calculate + ', ' + this.selectors.price_block);
		if (typeof window.product_removed_popup === 'function') {
			window.product_removed_popup(product_id);
		}
	},

	check_product_outofstock(product) {
		if (product.IsAvailableForCart) {
			return false;
		} else if (product.Availability && !product.Availability.Available) {
			const instock_caption = document.querySelector(this.selectors.instock_caption);
			const add_to_cart = document.querySelector(this.selectors.add_to_cart);

			document.querySelector('body').classList.add('outofstock');
			if (add_to_cart) {
				add_to_cart.classList.add('hide');
			}
			if (instock_caption) {
				instock_caption.classList.remove('hide');
				instock_caption.textContent = product.Availability.Description;
			}
			return true;
		}
	},

	check_product_availability(product) {
		if (!product.IsAvailableForCart || product.Availability && !product.Availability.Available) {
			const product_availability = document.querySelector(this.selectors.product_availability);

			if (product_availability && product.Availability && product.Availability.Description.length) {
				product_availability.textContent = product.Availability.Description;
				product_availability.classList.remove('hide');
			}
		}
	},

	call_for_price() {
		let result = false;
		if (document.querySelector(this.selectors.button_inquire)) {
			result = true;
		}
		if (this.is_adv_source()) {
			const use_map_price = document.querySelector(this.selectors.use_map_price);
			if (use_map_price && use_map_price.getAttribute('data-show-map-for-adwords').toLowerCase() !== 'true') {
				result = false;
			}
		}
		return result;
	},

	// Product options v1
	build_product_options(product_id) {
		if (window.product_options) {
			window.product_options.events.after_recalculating = base_price => {
				if (!this.call_for_price()) {
					this.update_price(base_price);
				}
			};
			window.product_options.build(document.querySelector(this.selectors.product_options), product_id);
		}
	},

	build_variations() {
		const variations = document.querySelector(this.selectors.product_variations);
		const expander = variations.querySelector('.js-variations-expander');
		if (variations) {
			const expand = function() {
				variations.classList.add('expanded');
			};
			expander.addEventListener('click', expand());
			if (variations.querySelectorAll('.product-variation').length <= 4) {
				expand();
			}
		}
	},

	get_cookie_value(cookie_name) {
		const cookie_value = document.cookie.match( '(^|;)\\s*' + cookie_name + '\\s*=\\s*([^;]+)' );
		return cookie_value ? cookie_value.pop() : '';
	},

	is_adv_source() {
		let adv = false;
		if (location.search && location.search.indexOf('gclid') > -1) {
			adv = true;
		}
		return adv;
	}
};

export default ProductUtils;